import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, throwError } from 'rxjs';
import { catchError, concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { BaseActionTypes } from '../../actions/base.actions';
import { State } from '../../index';
import { getToken } from '../../selectors/base.selectors';
import {
    GetSpezifikationsArtenResponse,
    SpezifikationsArtActionTypes,
} from '../../actions/mdqx/spezifikations-art.actions';
import { HttpService } from '../../../services/http.service';
import { SpezifikationsArtEntity } from '../../../entities/mdqx/spezifikations-art.entity';
import { DaveActions } from '../../actions/actions';

enum ErrorCodes {
    Get = 'SpezifikationsArten Abrufen fehlgeschlagen',
}

@Injectable()
export class SpezifikationsArtEffects {
    
    get$ = createEffect(() => this.actions$.pipe(
        ofType(SpezifikationsArtActionTypes.GetSpezifikationsArtenRequest),
        map(
            () => `
            {
                spezifikationsArt {
                    ${SpezifikationsArtEntity.GqlFields}
                }
            }`,
        ),
        withLatestFrom(this.store.select(getToken)),
        switchMap(([query, token]) =>
            this.api.graphQl({query}, {token}).pipe(
                map(res => res && res.spezifikationsArt),
                concatMap(res =>
                    res
                        ? [
                            new GetSpezifikationsArtenResponse(
                                res.map(
                                    spezifikationsArt =>
                                        new SpezifikationsArtEntity(spezifikationsArt),
                                ),
                            ),
                        ]
                        : throwError('empty response'),
                ),
                catchError((err, caught) => of(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: ErrorCodes.Get,
                        Err: err,
                        Caught: caught,
                    }
                }))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions<DaveActions>,
        private api: HttpService,
        private store: Store<State>,
    ) {
    }
}
